// import {getData, getSearchData} from "../../utils/communication";
import axios from "axios";
import {history} from 'home'
import {updateVersionAddData} from "../VersionAdd/versionAdd";

// const
const REDIRECT_TO_VERSION_EDIT = "versionEdit/REDIRECT_TO_VERSION_EDIT";
const VERSION_EDIT_UPDATE_DATA = "versionEdit/VERSION_EDIT_UPDATE_DATA";
const VERSION_EDIT_STORE_APPLICATION = "versionEdit/VERSION_EDIT_STORE_APPLICATION";
const VERSION_EDIT_STORE_VERSION = "versionEdit/VERSION_EDIT_STORE_VERSION";
const VERSION_EDIT_STORE_APP_PLANS = "versionEdit/VERSION_EDIT_STORE_APP_PLANS";
const VERSION_EDIT_STORE_SOURCE_TYPES = "versionEdit/VERSION_EDIT_STORE_SOURCE_TYPES";
const VERSION_EDIT_TOGGLE_LOADING = "versionEdit/VERSION_EDIT_TOGGLE_LOADING";
const VERSION_EDIT_TOGGLE_MODAL = "versionEdit/VERSION_EDIT_TOGGLE_MODAL";

//modal const
const VERSION_EDIT_MODAL_SUCCESS_TITLE = "scenes_Application_VersionEdit_modal_success_title";
const VERSION_EDIT_MODAL_FAIL_TITLE = "scenes_Application_VersionEdit_modal_fail_title";
//更新版本信息成功/失败
const VERSION_EDIT_MODAL_UPDATE_SUCCESS_CONTENT = "scenes_Application_VersionEdit_modal_updateSuccess_content";
const VERSION_EDIT_MODAL_UPDATE_FAIL_CONTENT = "scenes_Application_VersionEdit_modal_updateFail_content";
//更新版本状态成功/失败(后面加状态code)
const VERSION_EDIT_MODAL_UPDATE_STATUS_SUCCESS_CONTENT = "scenes_Application_VersionEdit_modal_updateStatusSuccess_content";
const VERSION_EDIT_MODAL_UPDATE_STATUS_FAIL_CONTENT = "scenes_Application_VersionEdit_modal_updateStatusFail_content";
const VERSION_EDIT_MODAL_OK_LABEL = "scenes_Application_VersionEdit_modal_OK_label";
const VERSION_EDIT_MODAL_RETURN_LABEL = "scenes_Application_VersionEdit_modal_return_label";
const VERSION_EDIT_MODAL_YES_LABEL = "scenes_Application_VersionEdit_modal_yes_label";
const VERSION_EDIT_MODAL_NO_LABEL = "scenes_Application_VersionEdit_modal_no_label";

// reducer
export const versionEdit = (state = {
  loading: false,
  flag: "",
  visible: false,
  index: 0,
  rowKey: 0,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  sourceTypes: [],
  viewScreenshots: [],
  visibleScreenshot: false,
  previewScreenshot: "",

  majorVersionId: "",
  applicationId: "",
  application: {
    id: "",
    name: "",
    logo: "",
    type: {id: "", name: ""}
  },
  versionId: "",
  version: {
    id: "",
    number: "",
    version: "",
    status: {code: ""},
    sourceType: {id: "", name: ""},
    description: "",
    screenHeight: "",
    screenshots: [],
    releaseDate: "",
    releaseCompanyName: "",
    releaseUserName: "",
    majorVersion: {
      id: "",
      number: "",
      authorities: [],
      createDate: "",
      createCompanyName: "",
      createUserName: "",
    },
  },
  versionStatusName: "",
  versionStatusCode: "",

  isModifyVersion: false,
  screenshots: [],
  // deploymentFile: [],
  helpFile: [],
  apiFile: [],
  testReportFile: [],
  authorities: [],
}, action) => {
  switch (action.type) {
    case REDIRECT_TO_VERSION_EDIT:
      return {
        ...state,
        applicationId: action.data.applicationId,
        versionId: action.data.versionId
      };
    case VERSION_EDIT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case VERSION_EDIT_STORE_APPLICATION:
      return {
        ...state,
        applicationId: action.data.id,
        application: action.data,
      };
    case VERSION_EDIT_STORE_VERSION: {
      const authorities = action.data.majorVersion.authorities.map(authority => {
        return {
          key: authority.id,
          code: authority.code,
          name: authority.name,
          description: authority.description,
        }
      });
      const screenshots = action.data.screenshots.map(screenshot => {
        return {
          uid: screenshot.id,
          name: screenshot.uri,
          lastModified: 0,
          status: "done",
          url: `/api-imagefiles/browse?name=${screenshot.uri}`,
        }
      });
      return {
        ...state,
        rowKey: 0,
        isModifyVersion: false,
        // deploymentFile: [],
        helpFile: action.data.detailFiles.filter(file => file.type === "HELP")[0],
        apiFile: action.data.detailFiles.filter(file => file.type === "API")[0],
        testReportFile: action.data.detailFiles.filter(file => file.type === "TEST_REPORT")[0],
        version: action.data,
        versionId: action.data.id,
        majorVersionId: action.data.majorVersion.id,
        applicationId: action.data.majorVersion.application.id,
        application: action.data.majorVersion.application,
        versionStatusName: action.data.status.name,
        versionStatusCode: action.data.status.code,
        authorities: authorities,
        screenshots: screenshots,
        viewScreenshots: screenshots
      };
    }
    case VERSION_EDIT_STORE_SOURCE_TYPES:
      return {
        ...state,
        sourceTypes: action.data
      };
    case VERSION_EDIT_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case VERSION_EDIT_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    default:
      return state
  }
};

/**
 * 前页跳转此页，需要传递参数：application.id、version.id
 */
export function redirectToversionEditPage(data) {
  return {
    type: REDIRECT_TO_VERSION_EDIT,
    data: data
  };
}

/**
 * update data based on user input
 */
export const updateVersionEditData = (data) => {
  return {
    type: VERSION_EDIT_UPDATE_DATA,
    data: data
  }
};

/**
 * check application and get versions
 */
export const initVersion = (data) => (dispatch) => {
  let versionId = data.versionId;
  dispatch(updateVersionEditData({
    name: "flag",
    value: data.flag
  }));
  dispatch(toggleLoading(true));
  if (versionId !== null && versionId !== undefined && versionId !== "") {
    axios.get(`/api-application/getVersionById/${versionId}`, {contentType: "application/json"}).then(
      response => {
        dispatch(toggleLoading(false));
        if (response.data) {
          dispatch(storeVersion(response.data));
        } else {
          history.push("/exception/415");
        }

      }
    );
  } else {
    dispatch(toggleLoading(false));
    history.push("/exception/415");
  }
};

/**
 * store single version
 */
export const storeVersion = (version) => {
  return {
    type: VERSION_EDIT_STORE_VERSION,
    data: version
  }
};

/**
 * get all sourceTypes
 */
export const getSourceTypes = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-application/getSourceType", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeSourceTypes(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all sourceTypes
 */
export const storeSourceTypes = (sourceTypes) => {
  return {
    type: VERSION_EDIT_STORE_SOURCE_TYPES,
    data: sourceTypes
  }
};

/**
 * submit data
 */
export const updateVersion = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: "/api-application/updateVersion",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "id": data.versionId,
      "status": {"code": "0"},
      "description": data.description,
      "screenHeight": data.screenHeight,
      "screenshots": data.screenshots,
      "sourceType": {"code": data.sourceType},
      // "deploymentFile": data.deploymentFile,
      "helpFile": data.helpFile,
      "apiFile": data.apiFile,
      "testReportFile": data.testReportFile,
      "releaseUserId": data.releaseUserId,
      "releaseUserName": data.releaseUserName,
      "releaseCompanyId": data.releaseCompanyId,
      "releaseCompanyName": data.releaseCompanyName,
      "authorities": data.authorities
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success update version", response.data);
        dispatch(storeVersion(response.data));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: VERSION_EDIT_MODAL_SUCCESS_TITLE,
          modalContent: VERSION_EDIT_MODAL_UPDATE_SUCCESS_CONTENT,
          modalOk: VERSION_EDIT_MODAL_YES_LABEL,
          modalCancel: VERSION_EDIT_MODAL_NO_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            dispatch(updateVersionStatus({
              versionId: data.versionId,
              versionStatus: "1"
            }));
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
          }
        }));
      }
      else {
        console.error("fail to update version");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: VERSION_EDIT_MODAL_FAIL_TITLE,
          modalContent: VERSION_EDIT_MODAL_UPDATE_FAIL_CONTENT,
          modalOk: VERSION_EDIT_MODAL_OK_LABEL,
          modalCancel: VERSION_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * update app version status
 */
export const updateVersionStatus = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  console.log(data);
  axios({
    method: "PUT",
    url: "/api-application/updateVersionStatus",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "id": data.versionId,
      "status": {"code": data.versionStatus}
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success update version status");
        dispatch(updateVersionEditData({
          name: "versionStatusCode",
          value: response.data.code,
        }));
        dispatch(updateVersionEditData({
          name: "versionStatusName",
          value: response.data.name,
        }));
        if (data.versionStatus === "3" || data.versionStatus === "5") {
          dispatch(sendMessage({
            actorId: data.releaseUserId,
            applicationId: data.applicationId,
            applicationName: data.applicationName,
            version: data.version,
            statusName: data.versionStatus === "3" ? "上线" : "下线",
          }));
        }
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: VERSION_EDIT_MODAL_SUCCESS_TITLE,
          modalContent: VERSION_EDIT_MODAL_UPDATE_STATUS_SUCCESS_CONTENT + data.versionStatus,
          modalOk: VERSION_EDIT_MODAL_OK_LABEL,
          modalCancel: VERSION_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
      else {
        console.error("fail to update version status");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: VERSION_EDIT_MODAL_FAIL_TITLE,
          modalContent: VERSION_EDIT_MODAL_UPDATE_STATUS_FAIL_CONTENT + data.versionStatus,
          modalOk: VERSION_EDIT_MODAL_OK_LABEL,
          modalCancel: VERSION_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};


/**
 * send message
 */
export const sendMessage = (data) => (dispatch) => {
  axios({
    method: "GET",
    url: `/api-application/getSubscribeUserIdsByApplicationId/${data.applicationId}`,
    contentType: "application/json",
    withCredentials: true,
  }).then(
    response => {
      if (response.status === 200 && response.data) {
        axios({
          method: "post",
          url: "/api-user/notificationObjects",
          contentType: "application/json",
          withCredentials: true,
          data: {
            "actorId": data.actorId,
            "notifierIds": response.data,
            "title": `版本${data.statusName}通知`,
            "description": `您所订阅的应用【${data.applicationName}】中版本【${data.version}】${data.statusName}！`,
            "type": "用户消息",
            "selfType": "02",
            "action": "版本状态变更",
            "ways": "sendEmail"
          }
        }).then(
          response => {
            if (response.status === 200) {
              console.info("success to send a message");
            } else {
              console.error("fail to send a message")
            }
          },
          error => {
            console.error("fail to send a message", error)
          }
        );
      }
    }
  );
};

/**
 * toggle modal
 */
export const toggleLoading = (show) => {
  return {
    type: VERSION_EDIT_TOGGLE_LOADING,
    data: show
  }
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: VERSION_EDIT_TOGGLE_MODAL,
    data: show
  }
};
